module.exports = __webpack_public_path__ + "img/浙贝母.c4df7b07.jpg";